import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { MypageContext, useMypageStore } from '../context';
import { getChatHostname } from 'utils/hostnameUtil';

const RanMemo = observer(({ item, onClose, category = '' }) => {
  const iframeRef = useRef(null);
  let { chatHostNameWithProtocol } = getChatHostname();
  const type = item.type || 'POINT';
  const title = type === 'ITEM' ? '랜덤 아이템 쪽지 보내기' : '랜덤 포인트 쪽지 보내기';

  const [loading, setLoading] = useState(true);

  const onClickCancel = () => {
    onClose();
  };

  return (
    <>
      <div className='account_info_wrap' style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div className='nav' style={{ flex: '0 0 auto' }}>
          <h2 className='tit'>{title}</h2>
          <button className={'btn_close'} onClick={onClickCancel} />
        </div>
        <div className='info_change_area' style={{ flex: '1 1 auto' }}>
          {loading && <div className='loading_spinner'></div>}
          <iframe
            style={{ width: '100%', height: '600px' }}
            ref={iframeRef}
            className='box-chat-iframe'
            scrolling='no'
            frameBorder='0'
            id='livechat'
            src={chatHostNameWithProtocol + '/memo/memo_form_rand.php?is_mobile=1&type=' + type + '&it_id=' + item.id}
            onLoad={() => setLoading(false)}
          />
        </div>
      </div>
    </>
  )
});

export default RanMemo;
